import React from "react";
import { useModal } from "./ModalContext";
import ModalMessageBox from "Components/Co2Common/Modals/ModalMessageBox";

const ModalContainer: React.FC = () => {
    const { modalType, modalProps, hideModal } = useModal();

    if (!modalType) return null;

    return (
        <ModalMessageBox type={modalType} open={!!modalType} toggle={hideModal} onConfirm={modalProps.onConfirm} onClose={modalProps.onClose}
            title={modalProps.title}
            description={modalProps.description}
            question={modalProps.question}
            inputLabel={modalProps.inputLabel}
            initialValue={modalProps.initialValue}
            icon={modalProps.icon}
            tone={modalProps.tone}
        />

    );
};

export default ModalContainer;
